define('services/auth',['require','exports','module','env','mdauth','./auth/company'],function(require, exports, module) {
    "use strict";

    var env = require("env"),
        lastCompanyId,
        MdAuth = require("mdauth"),
        authService = MdAuth({config: env, DEBUG: false}),
        AuthCompany = require('./auth/company'),
        authCompany = new AuthCompany(env);

    module.exports = {
        getCompanyId: function () {
            var companyId = location.search.split('company_id=')[1];
            if (companyId) {
                companyId = companyId.split('&')[0];
            }
            return companyId;
        },
        login: function(callback) {
            var companyId = this.getCompanyId();
            if (companyId) {
                lastCompanyId = companyId;
            }

            authService.login(callback);
        },

        getAuthInfo: function () {
            return authService ? authService.getAuthInfo() : {};
        },
        getCompanyInfo: function (callbackOk, callbackError) {
            var cid = lastCompanyId || this.getAuthInfo().getCompanyId();
            authCompany.get(callbackOk, callbackError, cid);
        },

    };

});

